window.addEventListener("DOMContentLoaded", ()=> {
    let bundleProductsList
    const currentUrl = window.location.href;
    const isByobPage = currentUrl.includes("byob");
    const PRODUCT_IMG_BASE_URL = "//www.renzosvitamins.com/cdn/shop/";

    const rechargeWidget = document.querySelector(".recharge-bundles-widget");
    if (rechargeWidget) rechargeWidget.style.display = "none";

    const byobCollectionBtns = document.querySelectorAll(".byob-card__addCart-button");
    const gamificationCounter = document.querySelectorAll(".byob-gamification-counter");
    const byobGamImgs = document.querySelectorAll(".bundle-image");
    const byobAtcBtnEl = document.querySelectorAll(".byob-atc-button"); 
    const isByobContainerEl = document.querySelector(".byob-gamification-container");
    const closeByobContainerEl = document.querySelector(".byob-down-arrow");
    const mobileByobBtn = document.querySelector(".mobile-open-byob-btn");
    const sbsPriceContainer = document.querySelector(".sbs-container-head .price-container");
    const otpPriceContainer = document.querySelector(".otp-container .price-container");
    const rechargeMetafieldDiscount = document.querySelector(".save-byob-discount");
    const contentSubsOtpBadge = document.querySelectorAll(".byob-sub-otp-section .sbs-otp-container .save-card");
    const contentSubsChecks = document.querySelectorAll(".byob-sub-otp-section .sbs-otp-container .benefits-container svg circle");
    const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <rect width="15" height="15" rx="7.5" fill="black"/>
                            <path d="M7.5 7.7895L5.35492 9.93458C5.31676 9.97274 5.26987 9.99318 5.21426 9.99591C5.15865 9.99864 5.10904 9.97819 5.06542 9.93458C5.02181 9.89096 5 9.84271 5 9.78983C5 9.73694 5.02181 9.68869 5.06542 9.64508L7.2105 7.5L5.06542 5.35492C5.02726 5.31676 5.00681 5.26987 5.00409 5.21426C5.00136 5.15865 5.02181 5.10904 5.06542 5.06542C5.10904 5.02181 5.15729 5 5.21017 5C5.26306 5 5.31131 5.02181 5.35492 5.06542L7.5 7.2105L9.64508 5.06542C9.68324 5.02726 9.73026 5.00681 9.78615 5.00409C9.84148 5.00136 9.89096 5.02181 9.93458 5.06542C9.97819 5.10904 10 5.15729 10 5.21017C10 5.26306 9.97819 5.31131 9.93458 5.35492L7.7895 7.5L9.93458 9.64508C9.97274 9.68324 9.99318 9.73026 9.99591 9.78615C9.99864 9.84148 9.97819 9.89096 9.93458 9.93458C9.89096 9.97819 9.84271 10 9.78983 10C9.73694 10 9.68869 9.97819 9.64508 9.93458L7.5 7.7895Z" fill="white" stroke="white" stroke-width="0.5"/>
                        </svg>`;
    const toggleShowEl = (el) => {
        el.style.display === "none" ? el.style.display = "block" : el.style.display = "none";
    };

    const updateBundleRechargeDiscounts = (bundleListObj) => {
        const isBundleEmpty = bundleListObj.length <= 0;
        const bundleDiscount = rechargeMetafieldDiscount.textContent; 
        const discount = Number(`0.${bundleDiscount}`);
        
        let rechargeTotal = bundleListObj.reduce((sum, item) => sum + parseFloat(item.price.replace('$', '')), 0);
        let sbsSaveDiscount = rechargeTotal * discount;
        let otpSave = parseFloat((rechargeTotal - 0).toFixed(2));
        const sbsTotalDiscount = parseFloat((rechargeTotal - sbsSaveDiscount).toFixed(2));

if (!isBundleEmpty) {
            sbsPriceContainer.innerHTML = `
                 <div class="original-price js-original-price-auto">$${rechargeTotal}</div>                  
                 <div class="price-sbs js-price-autoship">$${sbsTotalDiscount}</div>
                 
            `;
            otpPriceContainer.innerHTML = `
                <div class="original-price js-original-price-otp">$${rechargeTotal}</div> 
                <div class="price_otp js-price-otp">$${otpSave}</div>

            `;
        } else {
            sbsPriceContainer.innerHTML = `
                 <div class="original-price js-original-price-auto">$0.00</div>                  
                 <div class="price-sbs js-price-autoship">$0.00</div>              
            `;
            otpPriceContainer.innerHTML = `
                <div class="original-price js-original-price-otp">$0.00</div> 
                <div class="price_otp js-price-otp">$0.00</div>
            `;
        }
    };

    if (currentUrl && isByobPage) {
        bundleProductsList = [];

        const observer = new MutationObserver(() => {
            const productQuantityWrappers = document.querySelectorAll(".rb-qty-wrapper");
            if (productQuantityWrappers.length > 0) {
                observer.disconnect();
            }
        });
    
        observer.observe(document.body, { childList: true, subtree: true });

        byobCollectionBtns.forEach((button) => {
            button.addEventListener("click", function () {  

                const planIds = this.getAttribute("data-plans-ids")
                .split(",")
                .map(plan => plan.trim());

                const plans = this.getAttribute("data-plans-names")
                .split(",")
                .map(plan => plan.trim())
                .map((plan, index) => ({
                    id: planIds[index],
                    name: plan
                }))

                const bundleProduct = {
                    id: this.getAttribute("data-product-id"),
                    variantId: this.getAttribute("data-variant-id"),
                    title: this.getAttribute("data-product-title"),
                    price: this.getAttribute("data-product-price"),
                    media: this.getAttribute("data-product-media"),
                    plans: plans
                } 

                bundleProductsList.push(bundleProduct);
                addBundleProduct(bundleProductsList, bundleProduct.title);
                updateBundleRechargeDiscounts(bundleProductsList);
            })
        });

        const addBundleProduct = (bundleList) => {
            updateBundleGamification(bundleList, byobGamImgs);
        }; 

        const updateBundleGamification = (products, imageElements) => {
            let totalProducts = products.length;
            const isBundleComplete = totalProducts === 3;

            if(isBundleComplete) {
                byobAtcBtnEl[0].removeAttribute("disabled");
                byobCollectionBtns.forEach(btn => {
                    btn.setAttribute("disabled","");
                    btn.style.backgroundColor = "#b8b8b8";
                });
                byobAtcBtnEl[0].style.backgroundColor = "#F47820";
                byobAtcBtnEl[0].innerHTML = `<span class="byob-atc-button-text" style="color: #fff; cursor: pointer">
                    Add My Bundle
                </span>`;
                contentSubsOtpBadge.forEach(badge => {
                    badge.style.background = "#3ab9ab";
                });
                contentSubsChecks.forEach(check => { 
                    check.style.fill = "#3ab9ab";
                });
            } else {
                byobAtcBtnEl[0].setAttribute("disabled", "");
                byobCollectionBtns.forEach(btn => {
                    btn.removeAttribute("disabled");
                    btn.style.backgroundColor = "#f47820";
                });
                byobAtcBtnEl[0].innerHTML = `<span class="byob-atc-button-text" style="color: #fff">
                    Add ${totalProducts < 2 ? totalProducts+1 : totalProducts-1} products
                </span>`;
                contentSubsOtpBadge.forEach(badge => {
                    badge.style.background = "#9d9d9d";
                });
                contentSubsChecks.forEach(check => { 
                    check.style.fill = "#9d9d9d";
                });
            }

            /* UPDATE THE IMAGES */
            imageElements.forEach((el, index) => {
                if (products[index]) {
                    const imgWidth = products[index].media_width || 165;
                    const imgUrl = `${PRODUCT_IMG_BASE_URL}${products[index].media}`;
                    const imgSrcset = `
                        ${imgWidth >= 165 ? `${imgUrl}?width=165 165w,` : ''}
                        ${imgWidth >= 360 ? `${imgUrl}?width=360 360w,` : ''}
                        ${imgWidth >= 533 ? `${imgUrl}?width=533 533w,` : ''}
                        ${imgWidth >= 720 ? `${imgUrl}?width=720 720w,` : ''}
                        ${imgWidth >= 940 ? `${imgUrl}?width=940 940w,` : ''}
                        ${imgWidth >= 1066 ? `${imgUrl}?width=1066 1066w,` : ''}
                        ${imgUrl} ${imgWidth}w
                    `;

                    const sizes = `
                        (min-width: 1200px) calc((100vw - 130px) / 4),
                        (min-width: 990px) calc((100vw - 130px) / 4),
                        (min-width: 750px) calc((100vw - 120px) / 6),
                        calc((100vw - 35px) / 2)
                    `;
                    el.innerHTML = `
                     <div class="byob-gamification-remove-product" style="position: absolute; top: -10px; left: 54px; cursor: pointer">
                        ${svgContent} 
                    </div>
                    <img class="byob-product-img" 
                            src="${imgUrl}" 
                            alt="${products[index].title}" 
                            width="100%" 
                            height="auto"
                            srcset="${imgSrcset}" 
                            sizes="${sizes}" 
                            loading="lazy" />
                    `;
                    el.style.border = "1px solid #000";
                }else {
                    el.innerHTML = '*';
                    el.style.border = "2px dashed #B8B8B8";
                }

                const deleteBundleProduct = el.querySelector(".byob-gamification-remove-product");
                const bundleProductImg = el.querySelector(".byob-product-img");

                if(deleteBundleProduct) {
                    deleteBundleProduct.addEventListener("click", ()=> {
                        const bundleProductTitle = products[index]?.title;
                        const productIndex = bundleProductsList.findIndex(p => p.title === bundleProductTitle);
                        if (productIndex !== -1) {
                            bundleProductsList = bundleProductsList.filter((_, index) => index !== productIndex);
                        }

                        updateBundleRechargeDiscounts(bundleProductsList);
                        deleteBundleProduct.remove();
                        bundleProductImg.remove();
                        el.innerHTML = '*';
                        el.style.border = "2px dashed #B8B8B8";

                        /* ACTIVE BUNDLE PRODUCTS ATC BTN */
                        if (bundleProductsList.length < 3) {
                            byobCollectionBtns.forEach(btn => {
                                btn.removeAttribute("disabled");
                                btn.style.backgroundColor = "#f47820";
                            });
                            contentSubsOtpBadge.forEach(badge => {
                                badge.style.background = "#9d9d9d";
                            });
                            contentSubsChecks.forEach(check => { 
                                check.style.fill = "#9d9d9d";
                            });
                            byobAtcBtnEl[0].setAttribute("disabled", "");
                        }


                        byobAtcBtnEl[0].style.backgroundColor = "#b8b8b8";
                        byobAtcBtnEl[0].innerHTML = `<span class="byob-atc-button-text" style="color: #fff">
                            Add ${bundleProductsList.length < 2 ? bundleProductsList.length+1 : bundleProductsList.length-1} products
                        </span>`;

                        if(bundleProductsList.length === 0) {
                            byobAtcBtnEl[0].innerHTML = `<span class="byob-atc-button-text" style="color: #fff">
                                Add 3 products
                            </span>`;
                        };

                        gamificationCounter.forEach((counter) => {
                            counter.textContent = `(${bundleProductsList.length}/3)`;
                        }); 
                    })
                }
            });

            /* UPDATE COUNTER VALUE */
            gamificationCounter.forEach((counter) => {
                counter.textContent = `(${totalProducts}/3)`;
            });  
        }

        if(mobileByobBtn) {
            const observer = new MutationObserver(() => {
                const smileStartWidget = document.querySelector(".smile-launcher-frame-container.smile-launcher-border-radius-circular.smile-launcher-closed");
                const georgiasChatBtn = document.querySelector("#chat-button");
                const mByobBtn = document.querySelector(".byob-gamification-section_open");

                if (smileStartWidget || georgiasChatBtn) {
                    smileStartWidget.style.bottom = "70px";
                    georgiasChatBtn.style.bottom = "65px";

                    mByobBtn.addEventListener("click", () => {
                        const isByobContainerOpen = window.getComputedStyle(isByobContainerEl).display === "block";
                        smileStartWidget.style.display = isByobContainerOpen ? "none" : "block";
                        georgiasChatBtn.style.display = isByobContainerOpen ? "none" : "block";
                    });
                    observer.disconnect();
                }
            });
        
            observer.observe(document.body, { childList: true, subtree: true });
         
            mobileByobBtn.addEventListener("click", () => {
                toggleShowEl(isByobContainerEl);
            });
    
            closeByobContainerEl.addEventListener("click", ()=> {
                toggleShowEl(isByobContainerEl);
                const isByobContainerOpen = window.getComputedStyle(isByobContainerEl).display === "block";
                const georgiasChatBtn = document.querySelector("#chat-button");
                const smileStartWidget = document.querySelector(".smile-launcher-frame-container.smile-launcher-border-radius-circular.smile-launcher-closed");
                smileStartWidget.style.display = isByobContainerOpen ? "none" : "block";
                georgiasChatBtn.style.display = isByobContainerOpen ? "none" : "block";
            })
        } 
    };

    // ATC LOGIC

    const atcButtonBundle = document.querySelector('.byob-atc-button');
    atcButtonBundle.addEventListener('click', function() {

        const selectedPlanName = window.selectedPlanName || "Delivery every 30 Days"
        const itemsSelected = bundleProductsList;
        const isSubscriptionSelected = document.querySelector(".js-sbs-container").classList.contains("enabled-subs");

        const items = itemsSelected.map(item=>{
            const selling_plan = isSubscriptionSelected && item.plans.find(plan => plan.name === selectedPlanName)?.id;
            return {
                id: item.variantId,
                quantity: 1,
                ... ( selling_plan && {
                    properties: {
                    '_belongs_to_bundle': "byob"
                  }}
                ),
                ...(selling_plan && { selling_plan })
            }
        })
        let formData = {
            'items': items
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
            })
            .then(response => {
                setTimeout(() => {
                    window.diableSUbscritionSelectionOnBundleItems();
                },  1000)
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });

});